(function () {
  if (window.mobileSearchPlaceholderInitialized) return;
  window.mobileSearchPlaceholderInitialized = true;

  const input = document.getElementById('mobile-search-input');
  if (!input) return;

  const phrases = [
    'Rechercher un canapé...',
    'Rechercher une table...',
    'Rechercher un meuble...',
    'Rechercher une chaise...'
  ];

  let phraseIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let timer = null;
  let isRunning = false;

  function getTypingSpeed(current) {
    if (isDeleting) return 70;
    if (!isDeleting && charIndex === current.length) return 1800;
    if (isDeleting && charIndex === 0) return 900;
    return 140;
  }

  function clearTypingTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function step() {
    if (!isRunning) return;

    const current = phrases[phraseIndex];

    if (isDeleting) {
      charIndex = Math.max(0, charIndex - 1);
    } else {
      charIndex = Math.min(current.length, charIndex + 1);
    }

    input.placeholder = current.substring(0, charIndex);

    if (!isDeleting && charIndex === current.length) {
      isDeleting = true;
    } else if (isDeleting && charIndex === 0) {
      isDeleting = false;
      phraseIndex = (phraseIndex + 1) % phrases.length;
    }

    clearTypingTimer();
    timer = setTimeout(step, getTypingSpeed(current));
  }

  function startTyping() {
    if (isRunning || document.activeElement === input || input.value.trim()) return;
    isRunning = true;
    step();
  }

  function stopTyping() {
    isRunning = false;
    clearTypingTimer();
  }

  input.addEventListener('focus', function () {
    stopTyping();
    input.placeholder = '';
  });

  input.addEventListener('blur', function () {
    if (!input.value.trim()) {
      startTyping();
    }
  });

  startTyping();
})();
